import { 
    Component, 
    ChangeDetectionStrategy,
    ViewEncapsulation, 
    OnInit,
    EventEmitter,
    Output,
    ChangeDetectorRef
} from '@angular/core';
import { Router } from '@angular/router';
import { NavMenu } from '@app/shared/types/nav-menu.interface';
import { navConfiguration } from '@app/configs/nav.config'
import { AuthService } from '@app/services/auth.service';
import { io } from 'socket.io-client';
interface MenuDigi {
  formUrl: string;
  formName: string;
  unreadCount: string;
}
@Component({
    selector: 'vertical-menu-content',
    templateUrl: 'vertical-menu-content.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class VerticalMenuContentComponent implements OnInit {
    userRole = '';
    menu: MenuDigi[] = [];
    menuFlag: boolean = false;    
    asigedTable:any= this.auth.getTableName();
    clientName:any= this.auth.getClientName();
    socket: any;
    @Output() onNavLinkClick= new EventEmitter();

    constructor(private router: Router, private auth: AuthService, private cdr: ChangeDetectorRef) { 
    }

    ngOnInit(): void {
        this.updateMenu();
        console.log(this.menu);
        this.userRole = this.auth.getUserRole();
        this.socket = io(this.auth.geturl()); // backend URL

        this.socket.on('new-lead', (data:any) => {
            this.updateMenu();
        });
    }
    updateMenu(){
        setTimeout(() => {
            this.auth.getMenuData().subscribe((res:MenuDigi[])=>{
                this.auth.setMenuData(res);

                const existingUrls = new Set(this.menu.map(item => item.formUrl));

                const newItems = res.filter(item => !existingUrls.has(item.formUrl));

                if (newItems.length > 0) {
                    this.menu = [...this.menu, ...newItems];
                    this.auth.setMenuData(this.menu); 
                    this.cdr.detectChanges();
                }
                // this.menu = [...res];
                // console.log('Menu from API:', res);
                // console.log('Menu before update:', this.menu);
                // this.cdr.detectChanges();
            },(err:any)=>{
                console.log(err);
            });
        }, 300);
    }
    menuIsAllow(name:any){
        if(this.userRole == 'Admin' ||(this.userRole == 'Employee' && this.asigedTable.includes(this.clientName+'_'+name)))
            return true;
        else
            return false;
    }
    onLinkClick (path: string) {
        this.onNavLinkClick.emit(path)
    }

    isExisted(navTree, key: string) {

        if(!navTree) {
            return navTree
        }

        if( navTree.key === key ){
            return true;
        }
        let treeNode; 
        for (let p in navTree) {
            if( navTree.hasOwnProperty(p) && typeof navTree[p] === 'object' ) {
                treeNode = this.isExisted(navTree[p], key);
                if(treeNode){
                    return treeNode;
                }
            }
        }
        return treeNode;
    }
    
    getRouteTreeInfo(nodes: NavMenu[]) {
        let result: NavMenu;
        let found: boolean
        nodes.some((o: NavMenu) => {
            let submenu: NavMenu;
            if (o.path === this.router.url) {
                found = true
                return result = o;
            }
            if (o.submenu && (submenu = this.getRouteTreeInfo(o.submenu))) {
                return result = Object.assign({}, o, { submenu });
            }
        });

        return result;
    }
}